import React, { Component } from "react";

export default class LachakToranjRug extends Component {
  render() {
    let display = this.props.show ? "" : "none";
    // console.log(this.props.background)
    return (
      <div style={{ display: display }}>
        <div className="main-carpet-lachek-torang">
          <div className="background-carpet">
            <img
              alt="Lachak Toranj"
              src={
                this.props.background && this.props.background.image
                  ? this.props.background.image
                  : "/static/img/background.png"
			  }
			  onDragStart={(e) => e.preventDefault()}
            />
          </div>
          <div className="margin-carpet">
            <img
              alt="cover"
              src={
                this.props.border && this.props.border.image
                  ? this.props.border.image
                  : "/static/img/border.png"
			  }
			  onDragStart={(e) => e.preventDefault()}
            />
          </div>
          <div className="torange-carpet">
            <img
              alt="cover"
              src={
                this.props.toranj && this.props.toranj.image
                  ? this.props.toranj.image
                  : "/static/img/toranj.png"
			  }
			  onDragStart={(e) => e.preventDefault()}
            />
          </div>
          <div className="lecheck-carpet">
            <img
              alt="cover"
              src={
                this.props.corner && this.props.corner.image
                  ? this.props.corner.image
                  : "/static/img/corner.png"
			  }
			  onDragStart={(e) => e.preventDefault()}
            />
          </div>
        </div>
      </div>
    );
  }
}
